export default "__VITE_ASSET__59dc0ea0__"